function addCustomStylesToReviewWidget() {
  const targetWidgets = document.querySelectorAll('.gw-rv-average-placeholder');
  
  if (targetWidgets.length > 0) {
    targetWidgets.forEach(widget => {
      if (widget && widget.shadowRoot) {
        const customStyle = document.createElement('style');
        customStyle.id = 'custom-widget-styles';

        // Verifica se il widget ha la classe 'no-tooltip'
        const hasNoTooltip = widget.classList.contains('no-tooltip');
        if( hasNoTooltip ){
            customStyle.textContent = `
                .gw-rv-avg-rating {
                    column-gap: 0!important;
                }  
                .gw-rv-avg-rating svg{
                    width: 16px!important;
                    height: 16px!important;
                }
                .gw-rv-tooltip__tooltip {
                    display: none !important;
                    visibility: hidden !important;
                    pointer-events: none !important;
                    opacity: 0 !important;
                }`;
        }else{
            customStyle.textContent = `
                .gw-rv-avg-rating {
                    column-gap: 0!important;
                } 
                .gw-rv-avg-rating svg{
                    width: 16px!important;
                    height: 16px!important;
                }`;
        }
        
        if (!widget.shadowRoot.querySelector('#custom-widget-styles')) {
          widget.shadowRoot.appendChild(customStyle);
          //console.log('Stili applicati al widget:', widget);
        }

        // Controlla se il prodotto ha recensioni
        const ratingTextElement = widget.shadowRoot.querySelector('.gw-rv-average__rating_text');
        if (ratingTextElement) {
          let originalText = ratingTextElement.textContent.trim();
          // Estrai solo il numero dalle recensioni (es. "297" da "297 Recensioni")
          const reviewCount = originalText.match(/^\d+/);
          const numReviews = reviewCount ? parseInt(reviewCount[0]) : 0;
          
          // Nascondi il widget se non ci sono recensioni (numero = 0)
          if (numReviews === 0) {
            widget.style.display = 'none';
            return; // Esci dalla funzione senza applicare altri stili
          }
          // Assicurati che il widget sia visibile
          widget.style.display = 'block';
          
          // Rimuovi "Recensioni" e "Reviews" dal testo
          let cleanedText = originalText
            .replace(/\bRecensioni\b/gi, '')
            .replace(/\bReviews\b/gi, '')
            .trim(); // Rimuovi spazi extra
          
          // Aggiorna il testo solo se è cambiato
          if (cleanedText !== originalText) {
            ratingTextElement.textContent = cleanedText;
            ratingTextElement.style.color = "black";
            //console.log('Testo aggiornato da:', originalText, 'a:', cleanedText);
          }
        } else {
          // Se non trova l'elemento del testo, non fare nulla (il widget potrebbe non essere ancora caricato)
          return;
        }
      }
    });
  }
}

// Intersection Observer per rilevare quando gli elementi entrano nel viewport
function observeWidgetsInViewport() {
  const intersectionObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        //console.log('Widget entrato nel viewport:', entry.target);

        // Aspetta un po' per permettere al widget di caricarsi completamente
        setTimeout(() => {
          addCustomStylesToReviewWidget();
        }, 500);
        
        // Continua a controllare per un po' dopo che è entrato nel viewport
        let attempts = 0;
        const maxAttempts = 3;
        const checkInterval = setInterval(() => {
          attempts++;
          //console.log(`Tentativo ${attempts} di styling del widget nel viewport`);
          addCustomStylesToReviewWidget();
          
          if (attempts >= maxAttempts) {
            clearInterval(checkInterval);
          }
        }, 1000);
      }
    });
  }, {
    root: null, // viewport del browser
    rootMargin: '50px', // inizia a osservare 50px prima che entri nel viewport
    threshold: 0.1 // trigger quando almeno il 10% dell'elemento è visibile
  });

  // Osserva tutti i widget esistenti
  const widgets = document.querySelectorAll('.gw-rv-average-placeholder');
  widgets.forEach(widget => {
    intersectionObserver.observe(widget);
    //console.log('Osservando widget per viewport:', widget);
  });

  return intersectionObserver;
}

// Observer per elementi che si caricano dinamicamente
const mutationObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === 1) { // Element node
        const reviewWidgets = node.querySelectorAll ? 
          node.querySelectorAll('.gw-rv-average-placeholder') : [];
        
        // Se trova nuovi widget, li aggiunge all'intersection observer
        if (reviewWidgets.length > 0) {
          reviewWidgets.forEach(widget => {
            intersectionObserver.observe(widget);
            //console.log('Nuovo widget aggiunto all\'observer:', widget);
          });
        }
        
        // Se il nodo stesso è un widget
        if (node.classList?.contains('gw-rv-average-placeholder')) {
          intersectionObserver.observe(node);
          //console.log('Nuovo widget nodo aggiunto all\'observer:', node);
        }
      }
    });
  });
});

// Inizializza gli observer
let intersectionObserver;

document.addEventListener('DOMContentLoaded', () => {
  //console.log('DOM caricato, inizializzazione observer...');

  // Inizializza l'intersection observer
  intersectionObserver = observeWidgetsInViewport();
  
  // Inizializza il mutation observer
  mutationObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  // Prova anche subito per widget già caricati
  addCustomStylesToReviewWidget();
});

// Esegui anche se il DOM è già caricato
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    intersectionObserver = observeWidgetsInViewport();
    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
    addCustomStylesToReviewWidget();
  });
} else {
  intersectionObserver = observeWidgetsInViewport();
  mutationObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
  addCustomStylesToReviewWidget();
}

// Fallback: controlla periodicamente per i primi 10 secondi
let attempts = 0;
const maxAttempts = 3;
const intervalId = setInterval(() => {
  attempts++;
  //console.log(`Tentativo ${attempts} di applicare stili ai widget...`);
  addCustomStylesToReviewWidget();
  
  if (attempts >= maxAttempts) {
    clearInterval(intervalId);
    console.log('Completati tutti i tentativi di styling widget');
  }
}, 2000);